module.exports = __webpack_public_path__ + "img/img-error@2x.0780e718.png";